'use client';

import { type FormatDateOptions, FormattedMessage, useIntl } from 'react-intl';
import Image from '@alltrails/core/components/Image';
import IconButton from '@alltrails/denali/components/IconButton';
import ArrowSq from '@alltrails/denali/icons/ArrowSq';
import SponsoredBadge from '@/components/shared/SponsoredBadge';
import isUnpublished from '@/utils/isUnpublishedPost';
import styles from './styles/styles.module.scss';

type Props = {
  title: string;
  date: string;
  headerImageUrl?: string;
  author: string;
  status: string;
  is_sponsored: boolean;
};

// Designs: https://www.figma.com/design/Y27OVUVzKrRbVqPXo5MVmG/Newsroom-Phase-II?node-id=680-20874&m=dev
// Mobile: https://www.figma.com/design/Y27OVUVzKrRbVqPXo5MVmG/Newsroom-Phase-II?node-id=680-20281&m=dev

export default function Header({ title, date, headerImageUrl, author, status, is_sponsored }: Props) {
  const intl = useIntl();
  const formatOptions: FormatDateOptions = { month: 'short', day: 'numeric', year: 'numeric' };
  const backText = intl.formatMessage({ defaultMessage: 'Newsroom' });
  const isUnpublishedPressRelease = isUnpublished(status);
  const backLinkHref = '/newsroom';

  return (
    <div className={styles.header}>
      <div className={styles.headerInfoSection}>
        <div className={styles.backNav}>
          <IconButton
            className={styles.backButton}
            linkInfo={{ href: backLinkHref }}
            icon={{ Component: ArrowSq, orientation: 'left' }}
            variant="secondary"
            size="sm"
            title={backText}
          />
          <p>{backText}</p>
        </div>

        <h1 className={styles.title} dangerouslySetInnerHTML={{ __html: title }}></h1>
        {is_sponsored && <SponsoredBadge className={styles.sponsoredMargin} />}
        <p className={styles.author}>
          <FormattedMessage defaultMessage="By {author}" values={{ author }} />
        </p>
        {isUnpublishedPressRelease && <p className={styles.status}>{status}</p>}
        <p className={styles.date}>{intl.formatDate(date, formatOptions)}</p>
      </div>
      <div className={styles.headerImageContainer}>
        {/* TODO: localize the alt text, or add it to what we fetch from the WordPress API */}
        {headerImageUrl && <Image src={headerImageUrl} sizes="100vw" alt="Header Image" className={styles.headerImage} width={0} height={0} isLcp />}
      </div>
    </div>
  );
}
